"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _NumberFormat = _interopRequireDefault(require("../../NumberFormat"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    media: function media(_ref2) {
      var product = _ref2.product;
      return {
        position: 'relative',
        width: 276,
        height: 220,
        borderRadius: 5,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: product.image ? "url('".concat(product.image, "')") : '',
        backgroundSize: product.isTangoCard || product.isDonation ? 'contain' : 'cover',
        cursor: 'pointer'
      };
    },
    itemText: {
      wordBreak: 'break-word',
      wordWrap: 'break-word',
      width: 250
    },
    productName: {
      fontSize: 16,
      fontWeight: 'bold',
      lineHeight: 1.25,
      color: palette.text.primary,
      cursor: 'pointer',
      flexGrow: 1
    },
    productPrice: {
      fontWeight: 'bold'
    },
    flagImage: {
      flex: '0 0 18px',
      height: 18,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      '& > img': {
        height: '100%'
      }
    }
  };
});

var MarketplaceProduct = function MarketplaceProduct(_ref3) {
  var _product$localPrice, _product$localPrice2;

  var product = _ref3.product,
      onViewDetails = _ref3.onViewDetails,
      flag = _ref3.flag,
      children = _ref3.children,
      _ref3$wrapperProps = _ref3.wrapperProps,
      wrapperProps = _ref3$wrapperProps === void 0 ? {} : _ref3$wrapperProps,
      _ref3$overrideClasses = _ref3.overrideClasses,
      overrideClasses = _ref3$overrideClasses === void 0 ? {} : _ref3$overrideClasses;
  var classes = useStyles({
    product: product
  });
  var handleViewDetails = (0, _react.useCallback)(function () {
    if (onViewDetails) {
      onViewDetails(product);
    }
  }, [onViewDetails, product]);
  return /*#__PURE__*/_react["default"].createElement(_material.Box, (0, _extends2["default"])({
    width: [155, 276],
    maxWidth: [155, 276],
    display: "flex",
    position: "relative",
    flexDirection: "column",
    alignItems: "flex-start",
    "data-testid": "marketplace-product-item-".concat(product.id),
    textAlign: "left",
    mb: 4,
    mx: [1, 2],
    flex: "1 1 0",
    onClick: handleViewDetails
  }, wrapperProps), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: (0, _classnames["default"])(classes.media, overrideClasses.media),
    mb: 2
  }, children), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    mb: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: (0, _classnames["default"])(classes.productName, overrideClasses.productName, classes.itemText, overrideClasses.itemText)
  }, product.name)), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex"
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, null, !product.hasExternalFulfillment && /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: (0, _classnames["default"])('Body-Small-Inactive', classes.itemText, overrideClasses.itemText)
  }, product.provider), product.localPrice && /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: (0, _classnames["default"])('Tables-Textual-Bold', classes.productPrice, overrideClasses.productPrice)
  }, /*#__PURE__*/_react["default"].createElement(_NumberFormat["default"], {
    format: "".concat(product === null || product === void 0 ? void 0 : (_product$localPrice = product.localPrice) === null || _product$localPrice === void 0 ? void 0 : _product$localPrice.currencySign, "0,0.00")
  }, product === null || product === void 0 ? void 0 : (_product$localPrice2 = product.localPrice) === null || _product$localPrice2 === void 0 ? void 0 : _product$localPrice2.price))), flag && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: classes.flagImage
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: flag,
    alt: "Product country"
  }))));
};

var _default = /*#__PURE__*/(0, _react.memo)(MarketplaceProduct);

exports["default"] = _default;